import Axios from 'axios'

const examProfile = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.PROFILE_EXAMS_BASE_URL
    return AxiosInstance
  },
  createExamProfile (item) {
    return Axios.post('/profile', item)
  },
  editExamProfile (item) {
    return this.axios().put('/profile/' + item.id_profile, item)
  },
  deleteExamProfile (id) {
    return this.axios().delete('/profile/' + id)
  },
  getExamProfiles () {
    return this.axios().get('/profile')
  },
  getExamProfileById (id) {
    return this.axios().get('/profile/' + id)
  },
  getBranches () {
    return this.axios().get('/laboratory/affiliate')
  }
}

export default examProfile
